import React, { useEffect, useState } from "react";
import api from "../api/axios";
import { toast } from "react-toastify";
import { Save, X } from "lucide-react";

function EditProductVariant({ variant, onClose, onUpdate }) {
  const [brands, setBrands] = useState([]);
  const [presentations, setPresentations] = useState([]);
  const [formData, setFormData] = useState({
    brand_id: "",
    presentation_id: "",
    invima_code: "",
    batch_number: "",
    expiration_date: "",
    quantity: 0,
  });

  useEffect(() => {
    if (variant) {
      setFormData({
        brand_id: variant.brand_id || "",
        presentation_id: variant.presentation_id || "",
        invima_code: variant.invima_code || "",
        batch_number: variant.batch_number || "",
        expiration_date: variant.expiration_date
          ? variant.expiration_date.slice(0, 10)
          : "",
        quantity: variant.inventories?.[0]?.current_quantity || 0,
      });
    }

    fetchBrands();
    fetchPresentations();
  }, [variant]);

  const fetchBrands = async () => {
    try {
      const res = await api.get("/brands");
      setBrands(res.data);
    } catch (error) {
      toast.error("Error al cargar marcas");
    }
  };

  const fetchPresentations = async () => {
    try {
      const res = await api.get("/presentations");
      setPresentations(res.data);
    } catch (error) {
      toast.error("Error al cargar presentaciones");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/product-variants/${variant.id}`, formData);
      toast.success("Variante actualizada exitosamente");
      onUpdate(); // Refresca la lista en la modal principal
    } catch (error) {
      toast.error("Error al actualizar la variante");
      console.error(error);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[999]"
      onClick={(e) => e.stopPropagation()} // Evita cerrar la modal principal
    >
      <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-lg relative">
        {/* Botón cerrar */}
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-600 hover:text-red-500 text-xl"
        >
          <X size={24} />
        </button>

        <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
          Editar Variante
        </h2>

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Marca */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Marca
            </label>
            <select
              name="brand_id"
              value={formData.brand_id}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Seleccionar marca</option>
              {brands.map((brand) => (
                <option key={brand.id} value={brand.id}>
                  {brand.name}
                </option>
              ))}
            </select>
          </div>

          {/* Presentación */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Presentación
            </label>
            <select
              name="presentation_id"
              value={formData.presentation_id}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Seleccionar presentación</option>
              {presentations.map((presentation) => (
                <option key={presentation.id} value={presentation.id}>
                  {presentation.name}
                </option>
              ))}
            </select>
          </div>

          {/* Invima */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Código INVIMA
            </label>
            <input
              type="text"
              name="invima_code"
              value={formData.invima_code}
              onChange={handleChange}
              placeholder="Ej: INV-12345"
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Lote y Vencimiento */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Lote
              </label>
              <input
                type="text"
                name="batch_number"
                value={formData.batch_number}
                onChange={handleChange}
                placeholder="Número de lote"
                className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Vencimiento
              </label>
              <input
                type="date"
                name="expiration_date"
                value={formData.expiration_date}
                onChange={handleChange}
                className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Cantidad */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Cantidad
            </label>
            <input
              type="number"
              name="quantity"
              value={formData.quantity}
              readOnly
              onChange={handleChange}
              min="0"
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Botones */}
          <div className="flex justify-start gap-4 mt-6">

            <button
              type="submit"
              className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-white px-5 py-2 rounded-lg shadow transition duration-300"
            >
              <Save size={18} />
              Guardar Cambios
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditProductVariant;
